module.exports = __webpack_public_path__ + "media/images/lock-3dff2930ef281dd735307d2bc97efb2cc35dacbda159b843af77737bdab6f4d4.svg";